import React, { Component } from 'react';
import {Modal, Button,Tabs,Tab,ButtonToolbar,OverlayTrigger,Tooltip} from 'react-bootstrap';
import Scrollbar from 'react-scrollbars-custom';
import {connect} from 'react-redux';
import { TextField } from '@rmwc/textfield';
import { Select } from '@rmwc/select';
import * as actionCreator from "../../action/index.js"
import WelcomeImage from '../../assets/images/welcomepop_up_arrow.png';
const baseUrl = process.env.REACT_APP_BASE_URL;
class Feedback extends React.Component {

render() {
if(this.props.const_var.crmSetting.is_CRM == true) {
    return null;
}

const shouldDisplayPopup = localStorage.getItem('WelcomePopupClosed')
    return (
       <div className='welcome-user'>
           <Modal centered show={this.props.const_var.iswelcomeModal && shouldDisplayPopup==null} backdrop='static' keyboard={false} onHide={(e)=>this.props.isOpenWelcomeModal(false,"actionclose")} dialogClassName="welcomemodal react-modal"   backdropClassName="ract-modal-pre-parent welcomeparent" >   
           
            <button className="close" onClick={(e)=>this.props.isOpenWelcomeModal(false,"actionclose")}><span className="icon-close"></span></button>
            <Modal.Body >
                    <div className='welcome-parent'>
                      {/* <div className="welcome-image arrow-img">
                          <img src={process.env.REACT_APP_BASE_URL +`${WelcomeImage}`} className="img-fluid"  />
                      </div> */}

                      <div className="arrow-content">
                          <h2>Hey, we’re glad to see you!</h2>
                          <h6>Please allow us to guide you through this amazing 3D Designer before you start designing your beautiful building.</h6>
                          <a className="act-btn btn btn-primary btn-xs" onClick={(e)=>{this.props.isOpenWelcomeModal(false,"actionclose");this.props.UsertourAction(true, '',0)}}>TAKE A TOUR</a>
                      </div>
                    </div>
             </Modal.Body>
          
                 
        </Modal>
        </div>
    )
  }
}

const mapStoreToProps = (state) => {
  return state.reducer
}


export default connect(
  mapStoreToProps,
  actionCreator
)(Feedback);